<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="1100px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Historia statusu
                </h1>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    :headers="requestStatusHistoryHeaders"
                    :items="requestStatusHistory"
                    hide-default-footer
                    disable-pagination
                    fixed-header
                    :mobile-breakpoint="0"
                    name="requestsHistoryData"
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.oldStatus.name }}
                            </td>
                            <td>
                                {{ item.newStatus.name }}
                            </td>
                            <td>
                                <template v-if="item.createdBy.firstName && item.createdBy.lastName">
                                    {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                                </template>
                                <template v-else>
                                    {{ item.createdBy.username }}
                                </template>
                            </td>
                            <td>
                                {{ formatDate(item.createdAt) }}
                            </td>
                        </tr>
                    </template>
                    <template slot="no-results" :value="true">
                        <p class="text-center">
                            Brak danych
                        </p>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onAbort"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'StatusHistoryDialog',
    mixins: [
        dateFormatter,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        requestStatusHistory: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            requestStatusHistoryHeaders: [
                {
                    text: 'Status przed',
                    value: 'oldStatus',
                    sortable: false,
                    width: 180
                },
                {
                    text: 'Status po',
                    sortable: false,
                    value: 'newStatus',
                },
                {
                    text: 'Zgłaszający',
                    sortable: false,
                    value: 'createdBy'
                },
                {
                    text: 'Data utworzenia',
                    sortable: false,
                    value: 'createdAt'
                }
            ]
        }
    },
    methods: {
        onAbort() {
            this.$emit('close-status-history-dialog')
        },
    }
}
</script>